import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Terms() {
  const navigate = useNavigate();
  const lastUpdated = "2026年5月21日";

  return (
    <div
      className="bg-slate-50 dark:bg-[#020617] text-slate-900 dark:text-slate-100"
      style={{ minHeight: "100dvh" }}
    >
      <header className="pt-safe px-4 pb-3 flex items-center gap-3 border-b border-slate-100 dark:border-slate-800 bg-white/80 dark:bg-slate-900/80 backdrop-blur-sm sticky top-0 z-10">
        <button
          onClick={() => navigate(-1)}
          className="p-2.5 rounded-full active:bg-slate-200 dark:active:bg-slate-800 transition-colors"
        >
          <ArrowLeft size={22} className="text-slate-600 dark:text-slate-400" />
        </button>
        <h1 className="text-lg font-black">利用規約</h1>
      </header>

      <div className="max-w-2xl mx-auto px-5 py-8 space-y-8 pb-16">
        <p className="text-sm text-slate-400">最終更新日：{lastUpdated}</p>

        <LegalSection title="第1条（適用）">
          本利用規約（以下「本規約」）は、locomoco（以下「本サービス」）の利用条件を定めるものです。
          登録ユーザーの皆さま（以下「ユーザー」）には、本規約に従って本サービスをご利用いただきます。
        </LegalSection>

        <LegalSection title="第2条（利用登録）">
          本サービスへの登録は、登録希望者が本規約に同意の上、所定の方法によって利用登録を申請し、
          運営者がこれを承認することによって完了します。
          以下に該当する場合、運営者は利用登録の申請を承認しないことがあります。
          <ul className="mt-2 ml-4 space-y-1 list-disc text-sm">
            <li>虚偽の事項を届け出た場合</li>
            <li>本規約に違反したことがある者からの申請である場合</li>
            <li>その他、運営者が利用登録を相当でないと判断した場合</li>
          </ul>
        </LegalSection>

        <LegalSection title="第3条（禁止事項）">
          ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。
          <ul className="mt-2 ml-4 space-y-1 list-disc text-sm">
            <li>法令または公序良俗に違反する行為</li>
            <li>犯罪行為に関連する行為</li>
            <li>本サービスのサーバーまたはネットワークの機能を破壊・妨害する行為</li>
            <li>本サービスの運営を妨害するおそれのある行為</li>
            <li>他のユーザーに関する個人情報等を収集または蓄積する行為</li>
            <li>他のユーザーに成りすます行為</li>
            <li>本サービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為</li>
            <li>その他、運営者が不適切と判断する行為</li>
          </ul>
        </LegalSection>

        <LegalSection title="第4条（本サービスの提供の停止等）">
          運営者は、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく
          本サービスの全部または一部の提供を停止または中断することができるものとします。
          <ul className="mt-2 ml-4 space-y-1 list-disc text-sm">
            <li>本サービスにかかるコンピュータシステムの保守点検または更新を行う場合</li>
            <li>地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合</li>
            <li>コンピュータまたは通信回線等が事故により停止した場合</li>
            <li>その他、運営者が本サービスの提供が困難と判断した場合</li>
          </ul>
          運営者は、本サービスの提供の停止または中断により、ユーザーまたは第三者が被ったいかなる不利益または損害についても、一切の責任を負わないものとします。
        </LegalSection>

        <LegalSection title="第5条（利用制限およびアカウント削除）">
          運営者は、ユーザーが以下のいずれかに該当する場合には、事前の通知なく、ユーザーの
          データを削除しまたはアカウントを停止することができるものとします。
          <ul className="mt-2 ml-4 space-y-1 list-disc text-sm">
            <li>本規約のいずれかの条項に違反した場合</li>
            <li>登録事項に虚偽の事実があることが判明した場合</li>
            <li>その他、運営者が本サービスの利用を適当でないと判断した場合</li>
          </ul>
        </LegalSection>

        <LegalSection title="第6条（退会）">
          ユーザーは、設定画面の「アカウントを削除する」から退会することができます。
          退会後、ユーザーの学習データ・アカウント情報は削除されます。なお、一度削除されたデータは復元できません。
        </LegalSection>

        <LegalSection title="第7条（免責事項）">
          運営者の債務不履行責任は、運営者の故意または重過失によらない場合には免責されるものとします。
          本サービスの利用に関連してユーザーに生じた損失・損害について、運営者は一切の責任を負いません。
        </LegalSection>

        <LegalSection title="第8条（サービス内容の変更等）">
          運営者は、ユーザーに通知することなく、本サービスの内容を変更しまたは本サービスの提供を
          中止することができるものとし、これによってユーザーに生じた損害について一切の責任を負いません。
        </LegalSection>

        <LegalSection title="第9条（利用規約の変更）">
          運営者は必要と判断した場合には、ユーザーに通知することなくいつでも本規約を変更することができるものとします。
          なお、本規約の変更後、本サービスの利用を開始した場合には、当該ユーザーは変更後の規約に同意したものとみなします。
        </LegalSection>

        <LegalSection title="第10条（準拠法・裁判管轄）">
          本規約の解釈にあたっては、日本法を準拠法とします。
          本サービスに関して紛争が生じた場合には、東京地方裁判所を専属的合意管轄とします。
        </LegalSection>

        <p className="text-xs text-slate-400 text-center pt-4">以上</p>
      </div>
    </div>
  );
}

function LegalSection({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section>
      <h2 className="text-base font-black text-slate-900 dark:text-white mb-2">{title}</h2>
      <div className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">{children}</div>
    </section>
  );
}
